import { Link } from "react-router-dom";
import { seoArticles } from "@/mocks/articles";

export default function ArticlesSection() {
  return (
    <section id="articles-section" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-2">
            SEO Articles & Guides
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Master OOPBuy Spreadsheet Intelligence
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto leading-relaxed">
            In-depth guides and tutorials to help you leverage spreadsheet data for smarter e-commerce product research and sourcing decisions.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              onClick={() => window.scrollTo(0, 0)}
              className="group bg-white border border-background-200/70 rounded-lg overflow-hidden hover:border-accent-300 transition-all cursor-pointer hover:-translate-y-0.5"
            >
              {/* Article Thumbnail */}
              <div className="w-full h-[180px] md:h-[200px] overflow-hidden bg-background-100">
                <img
                  src={article.image}
                  alt={article.imageAlt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              {/* Article Info */}
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
                  <span>{article.date}</span>
                  <span>&middot;</span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="text-base font-semibold font-heading text-foreground-900 group-hover:text-accent-600 transition-colors mb-2 leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-1 mt-4 text-xs text-accent-500 font-medium">
                  Read Article <i className="ri-arrow-right-line align-middle"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* View All Link */}
        <div className="text-center mt-10">
          <Link
            to="/oopbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full border-2 border-foreground-200 text-foreground-700 text-sm font-medium hover:border-accent-400 hover:text-accent-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Read the Full Guide <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}